import CustomErrorAlert from './CustomErrorAlert'

export default CustomErrorAlert
